var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { logger } from "../../logger";
import { JSON_PREFIX } from "../constant";
import StorageBlueprint from "./blueprint";
var WebStorage = /** @class */ (function (_super) {
    __extends(WebStorage, _super);
    function WebStorage(writeKey, backend) {
        var _this = _super.call(this, writeKey) || this;
        _this.backend = backend;
        return _this;
    }
    WebStorage.prototype.isAvailable = function () {
        try {
            var testKey = "__storage_test__";
            this.backend.setItem(testKey, "1");
            this.backend.removeItem(testKey);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    WebStorage.prototype.set = function (key, value) {
        if (typeof value === "boolean")
            value = value === true ? "true" : "false";
        if (typeof value === "object")
            value = JSON_PREFIX + JSON.stringify(value);
        this.backend.setItem(this.getKey(key), value);
    };
    WebStorage.prototype.get = function (key) {
        var value = this.backend.getItem(this.getKey(key));
        if (!value || typeof value !== "string")
            return null;
        if (["null", "undefined"].some(function (item) { return item == value; }))
            return null;
        if (value.startsWith(JSON_PREFIX)) {
            try {
                return JSON.parse(value.slice(JSON_PREFIX.length));
            }
            catch (error) {
                logger.error("[FORMO_ERROR] ".concat(this.backend.constructor.name, " failed to parse JSON"), error);
                return null;
            }
        }
        if (["true", "false"].some(function (item) { return item == value; })) {
            return JSON.parse(value);
        }
        return value;
    };
    WebStorage.prototype.remove = function (key) {
        this.backend.removeItem(this.getKey(key));
    };
    return WebStorage;
}(StorageBlueprint));
export default WebStorage;
//# sourceMappingURL=web.js.map